export const calculaIdade = async (dataNascimento: string): Promise<number> => {
  const [dia, mes, ano] = dataNascimento.split('/').map(Number);
  const dataAtual = new Date();
  let idade = dataAtual.getFullYear() - ano;
  if (
    dataAtual.getMonth() + 1 < mes ||
    (dataAtual.getMonth() + 1 === mes && dataAtual.getDate() < dia)
  ) {
    idade--;
  }
  return idade;
};
